module.exports = __webpack_public_path__ + "022ef3ad5a43b32e84de1d8f2667908b.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/help/sms-credit/sms-credit-ja.html
// module id = 1982
// module chunks = 0